import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseFormComponent } from '../../../../shared/base/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../../../../shared/base/base.service';
import { Constants } from '../../../../../app/app.constants';
import { OfferedProduct } from './../offered-products.models';
import { Product, UnitOfMeasurement } from '../../products/products.models';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { ProductsService } from '../../products/products.service';
import { BadgesService } from '../../badges/badges.service';
import { OptionsSource } from 'src/app/core/core.models';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { Dialog, DialogService } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';
import { ValueLabel } from "../../../../shared/base/base.models";
import { ProductCatalogue, ProductCatalogueHelper, ProductCatalogueItem, ProductCatalogueStatus } from '../../product-catalogues/product-catalogues.models';
import { ProductCataloguesService } from "../../product-catalogues/product-catalogues.service";
import { DxNumberBoxComponent, DxDataGridComponent } from "devextreme-angular";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-offered-products-form',
  templateUrl: './offered-products-form.component.html',
  styleUrls: ['./offered-products-form.component.scss']
})
export class OfferedProductsFormComponent extends BaseFormComponent implements OnInit {
  @ViewChild('regularPriceNumberBox', { static: true }) regularPriceNumberBox: DxNumberBoxComponent;
  @ViewChild('productItemsGrid') productItemsGrid: DxDataGridComponent;
  public pointsOfSale: OptionsSource;
  public products: OptionsSource;
  public badges: OptionsSource;
  public activeText: string = 'SHARED.ACTIVE';
  public isEditModalVisible = false;
  public newRegularPrice: number;
  public productCatalogueStatuses: ValueLabel[] = [];
  public ProductCatalogueStatus = ProductCatalogueStatus;
  public productCataloguesWithOfferedProduct: ProductCatalogue[] = [];
  public productCatalogueItemsWithOfferedProduct: ProductCatalogueItem[] = [];
  public selectedRowKeys: any[] = [];
  public changeRegularPriceModalLabel: string = '';
  public selectedProduct: Product;
  selectAllCheckBox: any;
  checkBoxUpdating = false;
  public quantityFormat: string = this.utilityService.twoDecimalFormat; // changeable by unitsOfMeasurement from the product
  public quantityLimitFormat: string = this.utilityService.twoDecimalWithNullFormat;
  public regularPriceStyle: any;

  constructor(
    private pointsOfSaleService: PointsOfSaleService,
    private productCatalogueService: ProductCataloguesService,
    private productsService: ProductsService,
    private badgesService: BadgesService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public transalteService: TranslateService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
    this.onEditorPreparing = this.onEditorPreparing.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
  }

  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.setRegularPriceStyle();

    this.url = `${Constants.contextPath}/offered-products`;
    this.prepareLookupData();
    this.prepareFormData(new OfferedProduct(), (response: OfferedProduct) => {
      response.breadcrumbsId = response.id;

      if (response.product) {
        let product = <Product>response.product;
        response.breadcrumbsId = product.name;
        response.product = product.id;
      }

      if (response.pointOfSale)
        response.pointOfSale = (<PointOfSale>response.pointOfSale).id;

      this.active = response.active;
      this.activeText = response.active ? 'SHARED.DEACTIVATE' : 'SHARED.ACTIVATE';
      return response;
    });
  }

  public setRegularPriceStyle(){
    this.regularPriceStyle = {
      valueChangeEvent: 'keyup',
      format: this.utilityService.twoDecimalFormat,
      readOnly: !((this.authorities.create && this.id == null) || (this.authorities.update && this.id != null)) || this.id != null,
      buttons: [
        {
          name: 'customButtonName1',
          location: 'after',
          options: { visible: this.id != null, onClick: this.openEditModal.bind(this), icon: 'edit', disabled: false, stylingMode: 'text', type: 'default', hint: this.transalteService.instant('OFFERED_PRODUCTS.CHANGE_REGULAR_PRICE') }
        }
      ]
    };
  }

  private prepareLookupData() {
    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
    this.products = this.productsService.getProductsLookup();
    this.badges = this.badgesService.getBadgesOptions();
    this.productCatalogueStatuses = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(ProductCatalogueStatus, true), 'value', 'label', 'ENUMS.PRODUCT_CATALOGUE_STATUS.');
  }

  public saveChanges(): void {
    if (!this.isFormValid())
      return;

    if (this.formData.badges)
      this.formData.badges = this.formData.badges.map(b => b.id ? b.id : b);

    if (this.id == null)
      this.baseService.create(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
    else
      this.baseService.update(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
  }

  isSelectable(item) {
    return item.status == 'ACTIVE';
}

  isSelectAll(productItemsGrid) {
    var items = [];

    productItemsGrid.getDataSource().store().load().done(function (data) {
        items = data;
    });

    var selectableItems = items.filter(this.isSelectable);
    var selectedRowKeys = productItemsGrid.option("selectedRowKeys");

    if (!selectedRowKeys.length) {
        return false;
    }
    return selectedRowKeys.length >= selectableItems.length ? true : undefined;
}

  onEditorPreparing(e) {
    var productItemsGrid = e.component;
    if (e.command === "select") {
        if (e.parentType === "dataRow" && e.row) {
            if (!this.isSelectable(e.row.data))
                e.editorOptions.disabled = true;
        } else if (e.parentType === "headerRow") {
            e.editorOptions.onInitialized = (e) => {
                this.selectAllCheckBox = e.component;
            }
            e.editorOptions.value = this.isSelectAll(productItemsGrid);
            e.editorOptions.onValueChanged = (e) => {
                if (!e.event) {
                    if (e.previousValue && !this.checkBoxUpdating) {
                        e.component.option("value", e.previousValue);
                    }
                    return;
                }
                if(this.isSelectAll(productItemsGrid) === e.value) {
                    return;
                }

                e.value ? productItemsGrid.selectAll() : productItemsGrid.deselectAll();

                e.event.preventDefault();
            }
        }
    }
  }

  onSelectionChanged(e) {
    var deselectRowKeys = [];
    e.selectedRowsData.forEach((item) => {
        if (!this.isSelectable(item))
            deselectRowKeys.push(e.component.keyOf(item));
    });
    if (deselectRowKeys.length) {
        e.component.deselectRows(deselectRowKeys);
    }
    this.checkBoxUpdating = true;
    this.selectAllCheckBox.option("value", this.isSelectAll(e.component));
    this.checkBoxUpdating = false;
  }

  productChanged = (event) => {
    this.selectedProduct = event.selectedItem;
    
    if(!Number.isInteger((<UnitOfMeasurement>this.selectedProduct.unitOfMeasurement).increment))
      this.quantityFormat = this.utilityService.twoDecimalFormat;
    else
      this.quantityFormat = this.utilityService.noDecimalFormat;
  }

  public openEditModal() {
    this.newRegularPrice = this.formData.regularPrice;
    this.changeRegularPriceModalLabel = `${this.transalteService.instant('OFFERED_PRODUCTS.CHANGE_REGULAR_PRICE')}: ${this.selectedProduct.code} ${this.selectedProduct.name}`;
    this.isEditModalVisible = true;
    this.productCatalogueService.getProductCataloguesByOfferedProduct(this.id, (productCatalogues) => {
      this.productCataloguesWithOfferedProduct = productCatalogues;
      setTimeout(() => {
        this.regularPriceNumberBox.instance.focus();
      }, 1000);
    })

  }

  public onSubmit() {
    if(this.newRegularPrice == null || this.newRegularPrice == undefined)
      this.alertService.error('OFFERED_PRODUCT.REGULAR_PRICE_NOT_NULL')
    else if (this.newRegularPrice == this.formData.regularPrice)
      this.alertService.error('OFFERED_PRODUCT.REGULAR_PRICE_NOT_SAME')
    else {
      let dialogData = new Dialog('PRODUCT_CATALOGUE.CHANGE_REGULAR_PRICE_MESSAGE', () => { 
      this.formData.regularPrice = this.newRegularPrice;
      this.saveChanges()
      this.isEditModalVisible = false;
      })
      this.dialogService.show(dialogData);
    }
  }

  public closeEditModal() {
    this.isEditModalVisible = false;
  }

  public deactivateItems() {
    if (this.selectedRowKeys.length == 0) {
      this.alertService.error('PRODUCT_CATALOGUES.NO_SELECTED_ITEMS');
      return;
    }

    let dialogData = new Dialog('PRODUCT_CATALOGUE.DEACTIVATE_ITEMS_MESSAGE', () => {
      let catalogues = [];
      let catalogueIds = [];
      this.selectedRowKeys.map(row => {
        catalogues.push(new ProductCatalogueHelper(row.id, row.items))
        catalogueIds.push(row.id);
      })
      this.productCatalogueService.deactivateItems(catalogues, () => {
        this.productCataloguesWithOfferedProduct = this.productCataloguesWithOfferedProduct.filter(pc => !catalogueIds.includes(pc.id));
        this.alertService.success('PRODUCT_CATALOGUES.ITEMS_DEACTIVATED')
      })
    })
    this.dialogService.show(dialogData);
  }

  getDisplayExprForProduct(item) {
    return !item ? '' : `${item.code} - ${item.name}`;
  }
}
